export interface ForgotPasswordErrors {
  email?: string;
}

export interface ResetPasswordFormData {
  code: string;
  password: string;
  password_confirm: string;
}

export interface ResetPasswordErrors {
  code?: string;
  password?: string;
  password_confirm?: string;
}

export enum ErrorMessages {
  PWD_RESET_FAILED_INCOMPLIANT_PASSWORD = 'errors.login.PWD_RESET_FAILED_INCOMPLIANT_PASSWORD',
  PWD_RESET_FAILED_CHECKSUM_MISMATCH = 'errors.login.PWD_RESET_FAILED_CHECKSUM_MISMATCH',
}
